( ($) => {

	let navigation = {

		bootstrap: () => {

		//	navigation.initResponsive();
		//	navigation.initToggle();

		//	$(window).on( 'resize', navigation.checkResponsive );

		},

		initResponsive: () => {

			navigation.checkResponsive();

		},

		checkResponsive: () => {

			// Alle aus der ersten Ebene
			let $navItems = $("header #main_menu > ul > li");

			// Navigation zurücksetzen
			navigation.reset();

			let top = $navItems.eq(0).offset().top;

			$navItems.each( function() {

				if( top !== $(this).offset().top ) {
					$("html").removeClass("has-nav-desktop");
				}

			} );


		},

		reset: () => {
			$("html").addClass("has-nav-desktop");
			$("html").removeClass("has-nav-toggled");
		},

		initToggle: () => {

			$(".navigation__toggle").click( () => {

				$("html").toggleClass("has-nav-toggled");

			} );

		}

	};

	$( navigation.bootstrap );

})(jQuery)